import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { BiUserCircle } from 'react-icons/bi';
import Hamburger from 'components/Navbar/Hamburger';
import { useAppSelector } from 'hooks/useStore';
import './index.css';

function Navbar({ transparent }: { transparent: boolean; }) {
    // Gate on `user` (not `authenticated`) — App.tsx routes on `user`, and
    // signIn(null) on a failed /students/ fetch leaves authenticated=true
    // with user=null, which would otherwise show app links on PublicRoutes.
    const { user } = useAppSelector(state => state.user);
    const { organization } = useAppSelector(state => state.organization);

    const activeLinkClassName = transparent
        ? 'navbar__link--active--transparent'
        : 'navbar__link--active';

    return (
        <div className={transparent ? 'navbar--transparent' : 'navbar'}>
            <div className='navbar__content'>
                <Link to='/'>
                    <img 
                        // src={TSCCLogo} 
                        src={organization.logo}
                        alt={organization.name}
                        className='navbar__logo'
                    />
                </Link>
                <div className='navbar__links'>
                    {/* App links are hidden until the student signs in — pre-login
                        these routes either redirect to /sign-in or don't exist. */}
                    {user && <>
                    {/* <NavLink
                        to='/tests/digital-act'
                        className={({ isActive }) => (isActive
                            ? activeLinkClassName
                            : organization.backgroundColor
                            ? 'navbar__link--light'
                            : 'navbar__link'
                        )}
                    >
                        ACT
                    </NavLink>
                    <NavLink
                        to='/tests/digital-sat'
                        className={({ isActive }) => (isActive
                            ? activeLinkClassName
                            : organization.backgroundColor
                            ? 'navbar__link--light'
                            : 'navbar__link'
                        )}
                    >
                        SAT
                    </NavLink>
                    <NavLink
                        to='/tests/digital-psat'
                        className={({ isActive }) => (isActive
                            ? activeLinkClassName
                            : organization.backgroundColor
                            ? 'navbar__link--light'
                            : 'navbar__link'
                        )}
                    >
                        PSAT
                    </NavLink> */}
                    <NavLink
                        to='/tests'
                        className={({ isActive }) => (isActive
                            ? activeLinkClassName
                            : organization.backgroundColor
                            ? 'navbar__link--light'
                            : 'navbar__link'
                        )}
                    >
                        Tests
                    </NavLink>
                    <NavLink
                        to='/assignments'
                        className={({ isActive }) => (isActive
                            ? activeLinkClassName
                            : organization.backgroundColor
                            ? 'navbar__link--light'
                            : 'navbar__link'
                        )}
                    >
                        Assignments
                    </NavLink>
                    {!organization.customizations.find(customization => customization === 'Hide Vocab') &&
                        <NavLink
                            to='/vocab'
                            className={({ isActive }) => (isActive
                                ? activeLinkClassName
                                : organization.backgroundColor
                                ? 'navbar__link--light'
                                : 'navbar__link'
                            )}
                        >
                            Vocab
                        </NavLink>
                    }
                    {organization.customizations.find(customization => customization === 'Video Lectures') &&
                        <NavLink
                            to='/lectures'
                            className={({ isActive }) => (isActive
                                ? activeLinkClassName
                                : organization.backgroundColor
                                ? 'navbar__link--light'
                                : 'navbar__link'
                            )}
                        >
                            Lectures
                        </NavLink>
                    }
                    {user?.customizations?.includes('FillApp Enabled') &&
                        <NavLink
                            to='/college-apps'
                            className={({ isActive }) => (isActive
                                ? activeLinkClassName
                                : organization.backgroundColor
                                ? 'navbar__link--light'
                                : 'navbar__link'
                            )}
                        >
                            College Apps
                        </NavLink>
                    }
                    </>}
                    {user
                        ?   <>
                                <NavLink
                                    to='/account'
                                    className={({ isActive }) => (isActive
                                        ? activeLinkClassName
                                        : organization.backgroundColor
                                        ? 'navbar__link--light'
                                        : 'navbar__link'
                                    )}
                                >
                                    <BiUserCircle className='navbar__icon' />
                                </NavLink>
                            </>
                        :   <NavLink 
                                to="/sign-in"
                                className={({ isActive }) => (isActive
                                    ? activeLinkClassName
                                    : organization.backgroundColor
                                    ? 'navbar__link--light'
                                    : 'navbar__link'
                                )}
                            >
                                Sign In
                            </NavLink>
                    }
                </div>
                <Hamburger transparent={transparent} />
            </div>
        </div>
    );
}

export default Navbar;